import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";

const SECTIONS = [
  {
    title: "1. Objet",
    text: "Les présentes Conditions Générales de Vente (CGV) régissent les ventes de licences de synchronisation de créations musicales conclues sur le site laconsoledesartistes.fr (ci-après « le Site »), édité par La Console des Artistes (ci-après « l'Éditeur »), entre l'Éditeur et tout acheteur (ci-après « le Client »). Toute commande implique l'acceptation pleine et entière des présentes CGV.",
  },
  {
    title: "2. Produits",
    text: "Le Site propose des licences de synchronisation non exclusives portant sur des créations musicales déposées par des artistes partenaires. Chaque licence autorise l'utilisation du morceau dans un (1) projet : publicité, film, production d'artiste ou contenu destiné aux réseaux sociaux. Les morceaux sont présentés avec une écoute en ligne permettant au Client de se faire une opinion avant achat.",
  },
  {
    title: "3. Prix",
    text: "Les prix sont affichés en euros (EUR) et fixés librement par chaque artiste. Des remises automatiques s'appliquent selon le nombre de morceaux commandés : −5 % dès 2 morceaux, −7 % dès 3, −10 % dès 5. Le prix facturé est celui affiché au moment de la validation de la commande.",
  },
  {
    title: "4. Paiement",
    text: "Le paiement s'effectue en ligne via PayPal (compte PayPal ou carte bancaire). La commande est considérée comme ferme après confirmation du paiement par PayPal. Les données bancaires transitent exclusivement par PayPal et ne sont jamais connues de l'Éditeur.",
  },
  {
    title: "5. Livraison",
    text: "Les produits sont dématérialisés : les fichiers masters sont disponibles au téléchargement immédiatement après validation du paiement, depuis l'espace client du Site, avec un certificat de licence au format PDF.",
  },
  {
    title: "6. Droit de rétractation — contenu numérique",
    text: "Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contenus numériques fournis immédiatement avec l'accord exprès du Client. En validant sa commande, le Client reconnaît que le téléchargement du master est disponible immédiatement et renonce expressément à son droit de rétractation.",
  },
  {
    title: "7. Propriété intellectuelle",
    text: "Les morceaux restent la propriété de leurs auteurs. La licence vendue est non exclusive, non cessible et limitée à un projet. Toute revente, redistribution ou utilisation hors du cadre de la licence est interdite. Les artistes déposants déclarent sur l'honneur détenir l'intégralité des droits sur leurs œuvres (accord de principe signé).",
  },
  {
    title: "8. Responsabilité",
    text: "L'Éditeur agit comme intermédiaire entre les artistes et les Clients. Il ne saurait être tenu responsable d'une méconnaissance des droits par un artiste déposant, celui-ci en portant l'entière responsabilité conformément à l'accord de principe signé.",
  },
  {
    title: "9. Données personnelles",
    text: "Les données collectées (identité, email, commandes) sont utilisées exclusivement pour l'exécution des ventes, l'envoi des confirmations et la gestion des comptes. Elles ne sont ni vendues ni transmises à des tiers. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression en écrivant via le formulaire de contact ou par email.",
  },
  {
    title: "10. Litiges",
    text: "Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée en priorité ; à défaut, les tribunaux français compétents seront saisis.",
  },
];

const CGV = () => (
  <main data-testid="cgv-page" className="mx-auto max-w-4xl px-5 pb-24 pt-32 sm:px-8">
    <SEO title="Conditions Générales de Vente" path="/cgv"
         description="CGV de La Console des Artistes : licences de synchronisation, prix, droits d'utilisation et conditions de téléchargement des musiques." />
    <Link
      to="/"
      data-testid="cgv-back"
      className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-amber-400"
    >
      <ArrowLeft className="h-4 w-4" /> Accueil
    </Link>
    <Reveal>
      <p className="mt-10 text-xs uppercase tracking-[0.35em] text-amber-500">Mentions légales</p>
      <h1 className="mt-3 font-display text-4xl font-black tracking-tighter sm:text-5xl">
        Conditions Générales de Vente
      </h1>
      <p className="mt-4 text-xs text-zinc-500">Dernière mise à jour : août 2026 — La Console des Artistes</p>
    </Reveal>
    <div className="mt-12 divide-y divide-white/[0.08] border-y border-white/[0.08]" data-testid="cgv-sections">
      {SECTIONS.map((s) => (
        <Reveal key={s.title}>
          <div className="py-8">
            <h2 className="font-display text-xl font-medium">{s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
    <Reveal>
      <p className="mt-10 border border-amber-500/30 bg-amber-500/5 p-6 text-xs leading-relaxed text-amber-200/80" data-testid="cgv-note">
        Ce document est un modèle indicatif rédigé pour La Console des Artistes. Faites-le valider
        par un professionnel du droit (avocat) avant mise en exploitation commerciale.
      </p>
    </Reveal>
  </main>
);

export default CGV;
